<template>
<div class="chapter">
<div class="inner_page">
<p class="Dedication-ded" id="ded"><span class="ePub-I">For Erin, Generation X; and Abigail and Delia, giving hope for whatever’s next</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?e36f69d4